import { completionRateConfig } from '@/lib/analytics/kpis/tiktok/mvConfig/completionRateConfig';
import { mediaViewerCommentsConfig } from '@/lib/analytics/kpis/tiktok/mvConfig/mediaViewerComments';
import { mediaViewerEngagementRate } from '@/lib/analytics/kpis/tiktok/mvConfig/mediaViewerEngagementRate';
import { mediaViewerEngagementRateOnViews } from '@/lib/analytics/kpis/tiktok/mvConfig/mediaViewerEngagementRateOnViews';
import { mediaViewerFavoritesConfig } from '@/lib/analytics/kpis/tiktok/mvConfig/mediaViewerFavorites';
import { mediaViewerLikesConfig } from '@/lib/analytics/kpis/tiktok/mvConfig/mediaViewerLikes';
import { mediaViewerReachConfig } from '@/lib/analytics/kpis/tiktok/mvConfig/mediaViewerReach';
import { mediaViewerReachRateConfig } from '@/lib/analytics/kpis/tiktok/mvConfig/mediaViewerReachRate';
import { mediaViewerSharesConfig } from '@/lib/analytics/kpis/tiktok/mvConfig/mediaViewerShares';
import { mediaViewerVideoDuration } from '@/lib/analytics/kpis/tiktok/mvConfig/mediaViewerVideoDuration';
import { mediaViewerVideoViewsAvgTimeWatchedConfig } from '@/lib/analytics/kpis/tiktok/mvConfig/mediaViewerVideoViewsAvgTimeWatched';
import { mediaViewerVideoViewsTotalTimeConfig } from '@/lib/analytics/kpis/tiktok/mvConfig/mediaViewerVideoViewsTotalTime';
import { mediaViewerViewsConfig } from '@/lib/analytics/kpis/tiktok/mvConfig/mediaViewerViews';
import { mediaViewerViewsRate } from '@/lib/analytics/kpis/tiktok/mvConfig/mediaViewerViewsRate';
import { POST, TI_POST_TYPES } from '@/lib/posts/postTypes';

const VIDEO_CONFIG = [
    // line 1
    mediaViewerViewsConfig,
    mediaViewerViewsRate,
    // line 2
    mediaViewerVideoViewsTotalTimeConfig,
    mediaViewerVideoViewsAvgTimeWatchedConfig,
    // line 3
    mediaViewerLikesConfig,
    mediaViewerCommentsConfig,
    // line 4
    mediaViewerFavoritesConfig,
    mediaViewerSharesConfig,
    // line 5
    mediaViewerEngagementRate,
    mediaViewerEngagementRateOnViews,
    // line 6
    mediaViewerReachConfig,
    mediaViewerReachRateConfig,
    // line 7
    completionRateConfig,
    mediaViewerVideoDuration
];

export const MediaViewerStatsTiktokBusiness = {
    [POST]: {
        [TI_POST_TYPES.TYPE_VIDEO]: VIDEO_CONFIG
    }
};
